import {isWaitfreeBm} from '../domain/content/[seriesId]/util/isWaitfreeBm';
import {Bm, SingleBadgeType} from '../graphql/generated/types';
import {BadgeTypeVo} from './shared/api/gateway/enums/BadgeTypeVo.enum';
import {PurchaseTypeVo} from './shared/api/nicolas/vo/enums/PurchaseTypeVo.enum';
import {LastViewDto} from './shared/api/nicolas/vo/LastViewDto.interface';
import {PurchaseInfoDto} from './shared/api/nicolas/vo/PurchaseInfoDto.interface';

export function getSingleBadge({
  is_free,
  hidden,
  bm,
  waitfreeBlocked,
  badge,
  last_view,
  purchaseInfo,
  canRead,
}: {
  is_free?: boolean;
  hidden?: boolean;
  badge?: BadgeTypeVo;
  bm?: Bm;
  waitfreeBlocked?: boolean;
  last_view?: LastViewDto;
  purchaseInfo?: PurchaseInfoDto;
  canRead?: boolean;
}): SingleBadgeType[] {
  const showLockBadge = !is_free && hidden;
  return [
    // 서버에서 등록된 후 1일동안 up 뱃지를 내려줌. 만약 열람 이력이 없고 Lock 되지 않았다면 뱃지를 보여줌
    ...(badge === BadgeTypeVo.Up && !showLockBadge && !last_view
      ? [SingleBadgeType.BadgeUpStatic]
      : []),
    ...(is_free ? [SingleBadgeType.LabelBadgeFree] : []),
    ...(bm && isWaitfreeBm(bm) && !waitfreeBlocked && !is_free
      ? [SingleBadgeType.BadgeTimeStatic]
      : []),
    ...(purchaseInfo &&
    ((purchaseInfo.purchase_type === PurchaseTypeVo.Rent && !is_free) ||
      purchaseInfo.purchase_type === PurchaseTypeVo.SetRent ||
      purchaseInfo.purchase_type === PurchaseTypeVo.Buy ||
      purchaseInfo.purchase_type === PurchaseTypeVo.SetBuy) &&
    canRead
      ? [PURCHASE_TYPE_BADGE_MAP[purchaseInfo.purchase_type]]
      : []),
  ];
}

const PURCHASE_TYPE_BADGE_MAP: {
  [key in Exclude<
    PurchaseTypeVo,
    PurchaseTypeVo.NotPurchased
  >]: SingleBadgeType;
} = {
  [PurchaseTypeVo.Rent]: SingleBadgeType.LabelBadgeRent,
  [PurchaseTypeVo.Buy]: SingleBadgeType.LabelBadgeOwn,
  [PurchaseTypeVo.SetBuy]: SingleBadgeType.LabelBadgeOwn,
  [PurchaseTypeVo.SetRent]: SingleBadgeType.LabelBadgeRent,
};
